<template>
    <div>
        <base-header type="gradient-success" class="pb-6 ">
        </base-header>
        <ShowUser/>

    </div>
</template>
<script>
    import ShowUser from "../../components/User/ShowUser";

    export default {
        components: {ShowUser},
        mounted() {


        },
        created() {

        }
    }
</script>
